import React, { useState } from 'react';

const Economia: React.FC = () => {
    const [objetivo, setObjetivo] = useState('');
    const [tempo, setTempo] = useState('');
    const [taxa, setTaxa] = useState('');

    const calcularEconomia = () => {
        if (!objetivo || !tempo || !taxa) return null;

        const O = parseFloat(objetivo);
        const t = parseInt(tempo);
        const i = parseFloat(taxa) / 100 / 12; // Taxa mensal

        const poupancaMensal = O / t;
        const investimentoMensal = O / ((Math.pow(1 + i, t) - 1) / i);

        return {
            poupancaMensal: poupancaMensal.toFixed(2),
            investimentoMensal: investimentoMensal.toFixed(2),
            poupancaTotal: O.toFixed(2),
            investimentoTotal: (investimentoMensal * t).toFixed(2)
        };
    };

    const resultado = calcularEconomia();

    return (
        <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Calculadora de Meta de Economia</h3>

            <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-4">
                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Objetivo (R$)
                                <input
                                    type="number"
                                    value={objetivo}
                                    onChange={(e) => setObjetivo(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="10000"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Tempo (meses)
                                <input
                                    type="number"
                                    value={tempo}
                                    onChange={(e) => setTempo(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="12"
                                />
                            </label>
                        </div>
                    </div>

                    <div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Taxa de retorno mensal (%)
                                <input
                                    type="number"
                                    value={taxa}
                                    onChange={(e) => setTaxa(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 mt-1"
                                    placeholder="0.5"
                                    step="0.1"
                                />
                            </label>
                        </div>
                    </div>
                </div>

                <div>
                    {resultado && (
                        <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-6">
                            <h4 className="text-lg font-semibold text-indigo-900 mb-4">Resultado:</h4>
                            <div className="space-y-3">
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Poupança mensal:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.poupancaMensal}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Investimento mensal:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.investimentoMensal}</span>
                                </div>
                                <div className="flex justify-between">
                                    <span className="text-indigo-700">Total poupando:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.poupancaTotal}</span>
                                </div>
                                <div className="flex justify-between text-lg">
                                    <span className="text-indigo-700">Total investindo:</span>
                                    <span className="font-bold text-indigo-900">R$ {resultado.investimentoTotal}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Economia;
